<template>
    <div class="page">
        
        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">Configurações</div>
                <div class="right">
                    <a style="opacity: 0" class="link panel-open" data-panel="left">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z" fill="black"></path>
                            <path d="M14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1045 10.8954 22 12 22C13.1046 22 14 21.1045 14 20Z" fill="black"></path>
                            <path d="M14 4C14 2.89544 13.1046 2.00001 12 2.00001C10.8954 2.00001 10 2.89544 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4Z" fill="black"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>        
        <div class="page-content">

            <div class="container hidden-xs hidden-md">
                <h2>Configurações</h2>
            </div>

            <form v-on:submit.prevent.stop="salvar">
                <div class="mt-20">
                    <div class="list mt-0 ">
                        <ul class="row" v-if="$root.user.tipo == 'admin'">
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Taxa adm. por consulta (%)</div>
                                    <div class="item-input-wrap">
                                        <money v-model="form['configuracoes'].objeto.taxaConsulta" v-bind="$root.config.money" class="input-text with-border"></money>
                                    </div>
                                </div>
                            </li> 
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Taxa adm. por procedimentos (%)</div>
                                    <div class="item-input-wrap">
                                        <money v-model="form['configuracoes'].objeto.taxaProcedimento" v-bind="$root.config.money" class="input-text with-border"></money>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Taxa adm. por exames (%)</div>
                                    <div class="item-input-wrap">
                                        <money v-model="form['configuracoes'].objeto.taxaExame" v-bind="$root.config.money" class="input-text with-border"></money>
                                    </div>
                                </div>
                            </li>                            
<!--                             <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Taxa de antecipação (%)</div>
                                    <div class="item-input-wrap">
                                        <the-mask :mask="['#','##', '##.#', '##.##']" :masked="true" type="tel" class="form-control" placeholder="__" :value="''" />
                                    </div>
                                </div>
                            </li>   -->
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Taxa de saque (R$)</div>
                                    <div class="item-input-wrap">
                                        <money v-model="form['configuracoes'].objeto.taxaSaque" v-bind="$root.config.money" class="input-text with-border"></money>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Tempo de repasse cartão (dias)</div>
                                    <div class="item-input-wrap">
                                        <input type="tel" v-model="form['configuracoes'].objeto.tempoCartao" placeholder="___" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>                              
                        </ul>                    
                    </div>                    

                </div>
                <div class="clearfix container">
                    <button type="submit" class=" button-large button button-fill">
                        <i class="las la-save"></i> 
                        Salvar informações
                    </button>
                    <br><br>
                </div>            
            </form>

        </div>
        
    </div>     
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'Configuracoes',
    components: {
        'Toolbar': Toolbar,
        'Top': Top,
    },          
    data () {
        var self                    = this;
        return {             
            "loaded":               false,
            "tab":                  "",
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,  
                "configuracoes":  {
                    "objeto": {
                        "taxaConsulta":         "",
                        "taxaSaque":            "",
                        "taxaProcedimento":     "",
                        "taxaExame":            "",
                        "tempoCartao":          ""
                    }
                }
            } 
        }
    },
    methods: {
        setTab: function(tab, scroll = true) {
            var self        = this;
            console.log("setTab()", tab);
            if (self.tab == tab) return false;
            self.tab        = tab;
            loading.show();

            self.getItens(scroll);
        },            
        getItens: function(scroll = true) {
            var self        = this;
            return new Promise(function(resolve, reject) {

                self.loaded             = false;
                loading.show();

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "nome":         self.tab
                    }
                };
                console.log("getItens()", form);

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("getItens() response", response);

                    self.form[response.data.result.nome] = response.data.result; 
                    self.loaded         = true;
                    self.$forceUpdate();
                    loading.hide();

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getItens() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
        salvar: function() {
            var self            = this;
            var form            = JSON.parse(JSON.stringify(self.form[self.tab]));
            form._cod           = self.$root.user.cod;
            form._token         = self.$root.user.token;
            form.nome           = self.tab;

            console.log("salvar()", form);            

            self.loading.salvar = true;
            loading.show();
            axios.put("api/itens.php", form)
            .then(response => {
                
                self.loading.salvar = false;
                console.log("salvar() response", response)
                loading.hide();

                alert(response.data.message);
                
            })
            .catch(error => {
                console.log("salvar() error", error)
                loading.hide();
                self.loading.salvar = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },             
    },
    created: function() {
    },
    activated: function() {
        var self = this;
        self.setTab("configuracoes", false);     

    },
    mounted: function() {
       
        // loading.hide();
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/Configuracoes.vue